import { render, staticRenderFns } from "./MealrequestPage.vue?vue&type=template&id=52c3c7b2&"
import script from "./MealrequestPage.vue?vue&type=script&lang=js&"
export * from "./MealrequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports